import { PartnerType } from '../../../../data-layer/partner/types';
import { PartnerRegistrationSteps as Steps } from '../types';

// Карта переходов для разных типов партнеров
const STEP_TRANSITIONS = {
    [PartnerType.SE]: new Map([
        [Steps.Register, Steps.Approve],
        [Steps.Approve, Steps.BankData],
        [Steps.BankData, Steps.Done],
    ]),
    [PartnerType.IE]: new Map([
        [Steps.Register, Steps.BankData],
        [Steps.BankData, Steps.Done],
    ]),
    [PartnerType.LLC]: new Map([
        [Steps.Register, Steps.SignerData],
        [Steps.SignerData, Steps.BankData],
        [Steps.BankData, Steps.Done],
    ]),
};

export const getNextStep = (partnerType: PartnerType, currentStep: Steps) =>
    STEP_TRANSITIONS[partnerType].get(currentStep) ?? currentStep;
